// 코드 정의 클래스가 상속할 부모 클래스

class CodeBase {
  constructor(codeMap) {
    this._codeMap = codeMap;

    this._valueTextArray = [];

    for(let code of Object.keys(codeMap)) {
      this._valueTextArray.push({ 'value' : code, 'text' : codeMap[code]});
    }
  }

  /*
    반환하는 형태
    [
      { 'value': 'A', 'text' : '작성중' },
      { 'value': 'B', 'text' : '대기' },
      { 'value': 'C', 'text' : '실행중' },
      { 'value': 'D', 'text' : '완료' },
      { 'value': 'E', 'text' : '중지' },
      { 'value': 'F', 'text' : '취소' }
    ]
  */
  get valueTextArray() {
    return this._valueTextArray;
  }

  /*
    반환하는 형태
    { A: "작성중", B: "대기", C: "실행중", D: "완료", E: "중지", F: "취소" }
  */
  get codeMap() {
    return this._codeMap;
  }

  /*
    코드에 맞는 텍스트. 코드에 맞는 텍스트가 없으면 undefined 반환
    codeText('A') // '작성중'
  */
  codeText(code) {
    return this._codeMap[code];
  }
}

export default CodeBase;
